import * as React from 'react';
import Timestamp from 'components/Timestamp';

import './styles/MessageListTimeItem.scss';

class MessageListTimeItem extends React.PureComponent<{
  date: Date;
}> {
  render() {
    return (
      <li className="MessageListTimeItem">
        <Timestamp className="MessageListTimeItem-date" date={this.props.date} format="long" />
      </li>
    );
  }
}

export default MessageListTimeItem;
